import React, { useState, useEffect } from "react";
import { getInsightText } from "../utils/getInsightText";



const ComparisonRow = ({
  label,
  zomato = 0,
  swiggy = 0,
  metricType,
  isCurrency = false
}) => {

  const [excelData, setExcelData] =  useState([])



  const formatValue = (val) =>
    isCurrency ? `₹${val?.toLocaleString()}` : val?.toLocaleString();

  const getPercentageDiff = () => {
    if (!zomato && !swiggy) return 0;
  
    const higher = Math.max(zomato, swiggy);
    const lower = Math.min(zomato, swiggy);
  
    if (lower === 0) return 100;
  
    return (((higher - lower) / lower) * 100).toFixed(1);
  };

  const getInsight = () => {
    if (zomato === swiggy) {
      return "Both platforms performed at a similar level.";
    }
  
    const percent = getPercentageDiff();
    const leader = zomato > swiggy ? "Zomato" : "Swiggy";
    const lagger = zomato > swiggy ? "Swiggy" : "Zomato";


    const dataRes = {
      "Zomato": zomato,
      "Swiggy":  swiggy,
      "Insight": getInsight
    }

  
    switch (metricType) {
  
      // -----------------------
      // VOLUME METRICS
      // -----------------------
  
      case "orders":
        return `${leader} is driving ${percent}% more orders, positioning it as the stronger volume engine.`;
  
      case "gmv":
        return `${leader} is generating ${percent}% higher revenue, reflecting stronger demand momentum.`;
  
      case "menuOpen":
        return `${leader} attracts ${percent}% more customer traffic, giving it stronger visibility and discovery advantage.`;
  
      case "cartbuild":
        return `${leader} shows ${percent}% higher cart activity, indicating stronger mid-funnel engagement.`;
  
      case "orderMake":
        return `${leader} converts ${percent}% more final purchases, demonstrating superior checkout conversion.`;
  
      // -----------------------
      // ADS PERFORMANCE
      // -----------------------
  
      case "adsMenuOpens":
        return `${leader} drives ${percent}% more ad-driven traffic, reflecting stronger campaign exposure.`;
  
      case "adsOrders":
        return `${leader} generates ${percent}% more ad-attributed orders, indicating better paid performance efficiency.`;
  
      case "adsSales":
        return `${leader} produces ${percent}% higher ad-generated revenue, showcasing stronger campaign monetization.`;
  
      case "adsSpend":
        return `Ad investment is ${percent}% higher on ${leader}, indicating stronger growth emphasis on that platform.`;
  
      case "roi":
        if (zomato > swiggy) {
          return `Zomato delivers ${percent}% stronger ROI, making it the more efficient advertising channel.`;
        }
        return `Swiggy delivers ${percent}% stronger ROI, offering better return on marketing spend.`;
  
      // -----------------------
      // DISCOUNT & BURN
      // -----------------------
  
      case "discount":
        return `${leader} is offering ${percent}% higher discounts, which may accelerate growth but increase margin pressure.`;
  
      case "burn":
        return `${leader} operates with a ${percent}% higher burn rate, suggesting heavier reliance on discounts and paid marketing to drive growth.`;
  
      case "adsDiscountBurn":
        return `${leader} has a ${percent}% higher combined ads and discount burn, impacting overall profitability.`;
  
  
      default:
        return "";
    }    
  };

  const insight = getInsightText(zomato, swiggy, metricType)


  const dataRes = {
    "Zomato": zomato,
    "Swiggy":  swiggy,
    "Insight": insight
  }

  useEffect(() => {
    setExcelData((prevData) => [
      ...prevData,
      dataRes,
    ]);
  }, []);





  const isAdvantageZomato = zomato > swiggy;

  return (
    <div className="grid grid-cols-4 py-4 border-b border-gray-100 text-sm items-center">

      <div className="font-medium text-gray-600">
        {label}
      </div>

      <div className="text-[#EF4F5F] font-semibold">
        {formatValue(zomato)}
      </div>

      <div className="text-[#FC8019] font-semibold">
        {formatValue(swiggy)}
      </div>

      <div
        className={`font-medium ${
          isAdvantageZomato ? "text-[#EF4F5F]" : "text-[#FC8019]"
        }`}
      >
        {insight}
      </div>
    </div>
  );
};

export default ComparisonRow;
